export default __webpack_public_path__ + "static/media/food-bills-v2.3df4a2ea.svg";